var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auto-reload" }, [
    _c("div", { staticClass: "btn-group" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          class: { green: _vm.autoReloadEnabled },
          attrs: { name: "autoReloadButton" },
          on: { click: _vm.toggleAutoReload }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("AUTO_REFRESH")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: { disabled: _vm.loading },
          on: { click: _vm.loadData }
        },
        [_c("i", { staticClass: "fa fa-refresh p-r-0" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }